import { Tabs } from "@/components/Elements";
import { Posts } from "./post";
import { Comments } from "./comments";
import { RecipientList } from "./messages";
import { UserSetting } from "./settings";
import { ProfileModel } from "../types";

const Tab = {
  Post: "Post",
  Comments: "Comments",
  Messages: "Messages",
  Settings: "Settings",
};

export const AccountDetail = ({ userDetail }: { userDetail: ProfileModel }) => {
  const { userId } = userDetail;

  return (
    <div className="w-[36vw]">
      <Tabs
        tabs={[
          {
            id: Tab.Post,
            label: Tab.Post,
            Content: () => <Posts userId={userId} />,
          },
          {
            id: Tab.Comments,
            label: Tab.Comments,
            Content: () => <Comments userId={userId} />,
          },
          {
            id: Tab.Messages,
            label: Tab.Messages,
            Content: () => <RecipientList userId={userId} />,
          },
          {
            id: Tab.Settings,
            label: Tab.Settings,
            Content: () => <UserSetting userDetail={userDetail} />,
          },
        ]}
      />
    </div>
  );
};
